/** /map and /map/ are the same route. */
export const isMapPath = (pathname) => String(pathname || '').replace(/\/+$/, '') === '/map';

/** Map state is transient: leaving /map drops it so a later visit starts clean. */
export const resetMapParams = (prev) => (prev.toString() ? new URLSearchParams() : prev);

/**
 * Preset handed over by in-app navigation (location.state.mapPreset), never by a URL.
 * Only allow-listed values survive: `allow` carries { commodities, layers, panels, statuses }.
 */
export const presetToParams = (preset, { commodities = [], layers = [], panels = [], statuses = [] } = {}) => {
  const params = new URLSearchParams();
  if (!preset || typeof preset !== 'object') return params;
  const { commodity, layer, panel, status, sidebarCollapsed } = preset;
  if (
    typeof commodity === 'string' &&
    commodities.some((c) => String(c).toLowerCase() === commodity.toLowerCase())
  ) {
    params.set('commodity', commodity);
  }
  if (layers.includes(layer) && layer !== 'all') params.set('layer', layer);
  if (panels.includes(panel)) params.set('panel', panel);
  if (Array.isArray(status)) {
    const valid = status.filter((v) => statuses.includes(v));
    if (valid.length > 0 && valid.length < statuses.length) params.set('status', valid.join(','));
  }
  if (sidebarCollapsed === true) params.set('sidebarCollapsed', '1');
  return params;
};
